import { IEventSchema } from '@faire/web-api--source/indigofair/data/IEventSchema';
import { trackClientEvent } from '@faire/web-api--source/trackClientEvent';
import { ITraceEventMarker } from '@faire/web/common/pete/TraceEventTracker';

export const eventKey = 'retailer_settings_page-email_preferences_tab-view';

/**
 * View of the tab content on the Email preferences page (tabs are FAIRE_SENT or BRAND_SENT).
 */
export function trackRetailerSettingsPageEmailPreferencesTabView(
  tab: string
): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
    priority: IEventSchema.Priority.EXTRA_LOW,
    parameters: { tab },
  });
}
